import axios from 'axios';

// В development режиме всегда используем localhost
// В production используем текущий домен
const isDevelopment = import.meta.env.DEV || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const API_BASE_URL = isDevelopment 
  ? 'http://localhost:8000/api/v1'
  : (import.meta.env.VITE_API_URL || `${window.location.origin}/api/v1`);

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Interceptors для обработки ошибок
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Редирект на логин
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

